import { useContext } from 'react';

import { useTheme } from '@chakra-ui/react';

import { CoreContext } from '../context/CoreContext';
import { getStripePromise } from '../utils/stripeUtil';

// The embedded_payment flag and the stripe block both come from get-checkout-data
// When the team is not setup for it, we keep the legacy redirection to a hosted payment page
const useReadStripePayment = (checkoutData, amountToPay, isTotalAboveZero) => {
  const { coreData } = useContext(CoreContext);
  const theme = useTheme();

  const isEmbeddedPayment = checkoutData != null && checkoutData.embedded_payment === true;
  const stripeData = isEmbeddedPayment ? checkoutData.stripe : null;
  const hasClientSecret = stripeData != null && stripeData.client_secret != null;
  const isAnonymousCheckout = coreData.user == null && !coreData.booking_engine.corporate;

  const isAnonymousEmbeddedPayment = isEmbeddedPayment && isAnonymousCheckout;
  const stripePromise = isAnonymousEmbeddedPayment && hasClientSecret ? getStripePromise(stripeData.publishable_key, stripeData.account_id) : null;

  return {
    // The card block follows the amount charged now, the deposit option can bring it down to zero
    canPayWithStripe: stripePromise != null && amountToPay > 0,
    // The misconfiguration follows the cart instead, so that no deposit choice can dismiss it
    isStripeMisconfigured: isAnonymousEmbeddedPayment && isTotalAboveZero && stripePromise == null,
    stripePromise,
    clientSecret: hasClientSecret ? stripeData.client_secret : null,
    brandColors: theme.colors.brand,
  };
};

export default useReadStripePayment;
